import { createSlice } from "@reduxjs/toolkit";

//CONSTANTS
export const PENDING = "pending";
export const DATA = "data";
export const ERROR = "error";

const initialState = {
  [PENDING]: false,
  [DATA]: {
    loggedIn: false,
  },
  [ERROR]: "",
};

// export const requestUserDataReducer = (state = initialState, action) => {
//   switch (action.type) {
//     case FETCH_USER_DATA_PENDING:
//       return {
//         ...state,
//         pending: true,
//       };
//     case FETCH_USER_DATA_SUCCESS:
//       return {
//         ...state,
//         pending: false,
//         data: action.payload,
//       };
//     case FETCH_USER_DATA_FAILED:
//       return {
//         ...state,
//         pending: false,
//         error: action.payload,
//       };
//     default:
//       return state;
//   }
// };

export const requestUserDataSlice = createSlice({
  name: "requestUserDataReducer",
  initialState: initialState,
  reducers: {
    updateUserDataState: (state, action) => {
      switch (action.payload.stateName) {
        case PENDING:
          return {
            ...state,
            [PENDING]: action.payload.value,
          };
        case DATA:
          return {
            ...state,
            [PENDING]: false,
            [DATA]: action.payload.value,
          };
        case ERROR:
          return {
            ...state,
            [PENDING]: false,
            [ERROR]: action.payload.value,
          };

        default:
          break;
      }
    },
  },
});

export const { updateUserDataState } = requestUserDataSlice.actions;

export const requestUserDataReducer = requestUserDataSlice.reducer;
